export default __webpack_public_path__ + "static/media/bad_luck.a2a82f29.png";